import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Product } from '../../../classes/product';

@Component({
  selector: 'app-manage-products',
  templateUrl: './manage-products.component.html',
  styleUrls: ['./manage-products.component.scss'],
})
export class ManageProductsComponent implements OnInit {
  subProducts: Product[];

  constructor(private activatedRoute: ActivatedRoute) {}

  ngOnInit() {
    this.getSubProducts();
  }

  getSubProducts() {
    this.activatedRoute.data.subscribe((response) => {
      this.subProducts = response.subProducts;
    });
  }
}
